<template>
	<div>
		<v-card flat color="transparent">
			<v-card-text>
				<v-row align="center">
                    <v-col cols="12" md="3" lg="3" xl="4" class="mx-0 px-0 mr-md-2 py-lg-0">
						<alternativeAutocompleteOne
                            :items="suppliers"
                            :valueInput="supplierId"
                            :loading="supplierLoading"
                           
                            @valueChange="(v) => {supplierId = v}"
                            @onChange="(v) => {index()}"
                           
                            :label="'Proveedor'"
                            classesContainer="width-auto"
                        ></alternativeAutocompleteOne>
					</v-col>
					<v-col cols="12" md="3" lg="2" xl="2" class="mx-0 px-0 pt-sm-0 mr-md-2 pb-sm-0">
                        <alternativeDatePickerRangeVCalendar
                            :valueInput="{start: dateRange.start_date, end: dateRange.end_date}"
                            @valueChange="(v) => {dateRange.start_date = v.start; dateRange.end_date = v.end; index(); delete serverErrors['date']}"
                            label="Fechas"
                        ></alternativeDatePickerRangeVCalendar>
						
					</v-col>
                   
					<v-spacer></v-spacer>
					<v-col  cols="12" md="4" lg="4" class="mx-0 pt-md-0 pt-6 pb-4 pb-md-1">
                        <v-row justify="end">
                            <iconButton :props="pdfBtnData" class="mr-2 mr-md-2 mb-3 mb-md-0">
                                <template slot="imgIcon">
                                    <img :src="pdfIcon" width="24" :class="pdfBtnData.disabled ? `filter-grey` : `filter-grey-darken-3`">
                                </template>
                            </iconButton>
                            <iconButton :props="exportBtnData"></iconButton>
                        </v-row>
					</v-col>
				</v-row>
				<v-row>
					<v-col class="mx-0 px-0">
						<v-card class="index-card">
                            <v-card-title class="body-1 font-weight-bold">
                                <v-col>
                                    <v-row class="primary">
                                        <v-col class="py-1 pb-0 text-sm-start text-center">
                                            <span>ADEUDO EN MXN:</span>
                                        </v-col>
                                        <v-col class="py-1 pb-0 text-sm-end text-center">
                                           
                                                <span>{{totalReport.mxn}}</span>
                                            
                                        </v-col>
                                    </v-row>
                                    <v-row class="primary">
                                        <v-col class="pt-0 pb-1 text-sm-start text-center">
                                            <span>ADEUDO EN USD:</span>
                                        </v-col>
                                        <v-col class="pt-0 pb-1 text-sm-end text-center">
                                           
                                                <span>{{totalReport.usd}}</span>
                                            
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-card-title>
                            <v-card-text >
                                <datatable :options="options" :props="tableProps" @methodHandler="method_handler" @handleOptions="handleOptions">
                           
                                </datatable>
                            </v-card-text>
                        </v-card>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>

     
	</div>
</template>
<script>
import pdfIcon from '../../../assets/pdf_icon_2.svg';
import Utils from '../../../helpers/Utils';
import PageStateManager from '../../../helpers/PageStateManager';
export default {
    data(){
		return {
            pdfIcon: pdfIcon,
            options: JSON.parse(PageStateManager.getState(this.$router.history.current.path, 'optionsIndexTable'))??{},
            total: 10,
			search: '',
            selectedID: '',
            totalReport: {mxn: '$0.00', usd: '$0.00'},
            dateRange: {
                start_date: PageStateManager.getState(this.$router.history.current.path, 'start_date')??Utils.getStartDate(), 
                end_date: PageStateManager.getState(this.$router.history.current.path, 'end_date')?? new Date().toISOString().split('T')[0]
            },
            supplierLoading: false,
            supplierId: PageStateManager.getState(this.$router.history.current.path, 'supplierId')??'all',
            suppliers: [],
			serverErrors: {},
			tableProps: {
				headers: [
					{
						text: 'Folio',
						align: 'left',
						value: 'folio',
						
						class: 'table-b-border black--text'
					},
                    {
						text: 'Proveedor',
						align: 'left',
						value: 'provider_name',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Referencia',
						align: 'center',
						value: 'reference_name',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Semana',
						align: 'center',
						value: 'week_number',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Vencimiento',
						align: 'center',
						value: 'due_date',
                        
						class: 'table-b-border black--text'
					},
                    {
						text: 'Días vencido',
						align: 'center',
                        
						value: 'due_date_in_days',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Adeudo',
						align: 'right',
                        
						value: 'pending_payment',
						class: 'table-b-border black--text'
					},
					
				],
				items: [],
				search: '',
				loading: true,
                elevation: '0'
			},
			
			
            exportBtnData: {
                hasTooltip:true,
                tooltip: 'Exportar excel',
                color:'primary',
                iconColor:'grey darken-3',
                height:'35',
                icon: "mdi-microsoft-excel",
                iconClass: "",
				to: "",
				block: false,
                loading:false,
                click: ()=>{this.export();}
            },
            pdfBtnData: {
                hasTooltip:true,
                tooltip: 'Exportar PDF',
                customIcon:true,
                color:'primary',
                iconColor:'grey darken-3',
                height:'35',
                icon: "mdi-progress-download",
                iconClass: "",
				to: "",
				block: false,
                loading: false,
               
                click: ()=>{this.pdf();}
            },

			
		}
	},
    watch: {
        /**
         * Reset values on "type" change
         */
        [`dateRange.start_date`]: function () {
            this.options.page = 1;
            PageStateManager.setState(this.$router.history.current.path, 'start_date', this.dateRange.start_date);
            
        },
        [`dateRange.end_date`]: function () {
            this.options.page = 1;
            PageStateManager.setState(this.$router.history.current.path, 'end_date', this.dateRange.end_date);
            
        },
        [`supplierId`]: function () {
            this.options.page = 1;
            PageStateManager.setState(this.$router.history.current.path, 'supplierId', this.supplierId);
            
        },
    },

	mounted(){
		this.index();
        this.getSuppliers();
        // window.addEventListener('resize', this.onResize, { passive: true });
        // this.onResize();
	},

    methods: {
        onResize () {
            
            if(window.innerWidth <= 960){
                this.exportBtnData.block = true;
                this.pdfBtnData.block = true;
                
            }
            else{
                
                this.exportBtnData.block = false;
                this.pdfBtnData.block = false;
            }
        },

       
        method_handler(object){
            console.log(object);
			this[object.methodName](object.parameters)
		},
        handleOptions(object){
            object.options[`search`] = this.tableProps.search;
			console.log(object.options, "optionss");
			this.options = object.options;
            PageStateManager.setState(this.$router.history.current.path, 'optionsIndexTable', JSON.stringify(this.options));
			// this.index();
		},
        trySearch(val){
            this.tableProps.search = val;
            this.options.page = 1;
            // this.index();
        },
		index() {
            if(this.dateRange.start_date == '' || this.dateRange.end_date == '' || this.supplierId == '')
                return;
            
            console.log()
           
            const request = JSON.parse(JSON.stringify({"start_date": this.dateRange.start_date, "end_date": this.dateRange.end_date, provider_id: this.supplierId})) 
			this.tableProps.loading = true;
            this.totalReport.mxn = this.totalReport.usd = Utils.currencyFormat(0, '');
            this.tableProps.items = [];
			//call api
			this.$api.report.reportBalanceDuePayableAccounts(this.$store.state.business, request)
				.then((resp) =>{
					console.log(resp);
                    this.totalReport.mxn = Utils.currencyFormat(resp.data.summary.total_mxn, '');
                    this.totalReport.usd = Utils.currencyFormat(resp.data.summary.total_usd, '');
					this.tableProps.items = resp.data.data.map((x) => {
						
						x.pending_payment = Utils.currencyFormat(x?.pending_payment??0, x.currency);
                        x.due_date = Utils.globalDateFormat(x.due_date);
						return x;
					});
                   
				})
				.catch((error) =>{
					console.log(error);
				})
				.finally(() => {
					this.tableProps.loading = false;
				})
			;
		
		},

        getSuppliers()
        {
            this.supplierLoading = true;
            this.$api.supplier.getSelectSuppliers(this.$store.state.business)
                .then((resp) => {
                    this.suppliers.push({"text": "Todos", "value": "all"});
                    this.suppliers.push(...resp.data);
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.supplierLoading = false;
                })
            ;
        },

        export()
        {
            if(this.dateRange.start_date == '' || this.dateRange.end_date == '' || this.supplierId == '')
                return;

            this.exportBtnData.loading = true;
            this.$store.state.loading = true;
            this.$api.report.exportReportBalanceDuePayableAccounts(this.$store.state.business, {"start_date": this.dateRange.start_date, "end_date": this.dateRange.end_date, provider_id: this.supplierId})
                .then((resp) => {
                    const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                    "download",
                    `payable_accounts.xls`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.exportBtnData.loading = false;
                    this.$store.state.loading = false;
                })
            ;
        },

        pdf()
        {
            if(this.dateRange.start_date == '' || this.dateRange.end_date == '' || this.supplierId == '')
                return;

            this.pdfBtnData.loading = true;
            this.$store.state.loading = true;
            this.$api.report.pdfReportBalanceDuePayableAccounts(this.$store.state.business, {"start_date": this.dateRange.start_date, "end_date": this.dateRange.end_date, provider_id: this.supplierId})
                .then((resp) => {
                    const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                    "download",
                    `payable_accounts.pdf`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.pdfBtnData.loading = false;
                    this.$store.state.loading = false;
                })
            ;
        }

    }
}
</script>